import {
  acessoUtils
} from "./util/acesso.utils";
import {
  cookieUtils
} from "./util/cookie.utils";

/**
 * Classe padrão para criação de Services no projeto
 */
export class Service {
  /**
   * Constroi a base dos controladores de request para a instância
   * do service;
   * @param {AbortController} controleDeInstancia Controlador caso seja
   * necessario o controle de uma instância como todo.
   */
  constructor(controleDeInstancia) {
    this.controleDeInstancia = controleDeInstancia;

    this.ultimosControladores = {
      get: new AbortController(),
      delete: new AbortController(),
      post: new AbortController(),
      patch: new AbortController()
    };
  }

  /**
   * Busca token jwt nos cookies e retorna
   * @returns {String} Token JWT
   */
  adquirirToken() {
    const token = cookieUtils.adquirirCookie('jwt');
    return token;
  }

  /**
   * Adquire o toastUtils dinâmicamente;
   * @returns ToastUtils
   */
  async adquirirToastUtils() {
    const { toastUtils } = await import('./util/toast.utils.js');
    return toastUtils;
  }

  async get(url, controlador) {
    this.ultimosControladores.get = this.selecionarControlador(controlador);
    const init = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.adquirirToken(),
      },
      signal: this.ultimosControladores.get.signal
    }
    const response = await fetch(url, init)
    if (response.ok) {
      return response.json()
    }
    if (response.status === 401) {
      acessoUtils.redirecionarSemTokenParaLogin();
    }
    throw new Error('HTTP ' + response.status)
  }

  async getFile(url, fileType = "image/png", controlador) {
    this.ultimosControladores.get = this.selecionarControlador(controlador);
    const init = {
      headers: {
        'Accept-Encoding': 'gzip, deflate',
        'Content-Type': fileType,
        'Accept': fileType,
        'Authorization': 'Bearer ' + this.adquirirToken()
      },
      signal: this.ultimosControladores.get.signal
    }

    return fetch(url, init).then(
      response => {
        if(response.ok) {
          return response.blob()
        }

        if (response.status === 401) {
          acessoUtils.redirecionarSemTokenParaLogin();
        }
      }
    ).catch(
      error => console.error(error)
    )
  }

  async downloadFile(url, fileType, filename, controlador) {
    this.ultimosControladores.get = this.selecionarControlador(controlador);
    const init = {
      headers: {
        'Accept-Encoding': 'application/octet-stream',
        'Content-Type': fileType,
        'Accept': fileType,
        'Authorization': 'Bearer ' + this.adquirirToken()
      },
      signal: this.ultimosControladores.get.signal
    };

    const response = await fetch(url, init);

    if (!response.ok) {
      if (response.status === 401) {
        acessoUtils.redirecionarSemTokenParaLogin();
        return;
      }

      const errorText = await response.text();
      throw new Error(`Erro ao baixar arquivo: ${response.status} - ${errorText}`);
    }

    const blob = await response.blob();
    const data = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    try {
      link.click();
    } finally {
      link.remove();
      URL.revokeObjectURL(data);
    }
  }

  async visualizarFile(url, fileType, controlador) {
    this.ultimosControladores.get = this.selecionarControlador(controlador);
    const init = {
      headers: {
        'Accept-Encoding': 'application/octet-stream',
        'Content-Type': fileType,
        'Accept': fileType,
        'Authorization': 'Bearer ' + this.adquirirToken()
      },
    signal: this.ultimosControladores.get.signal
  }

  return fetch(url, init).then(
    response => {
      if (response.ok) {
        return response.blob()
      }

      if (response.status === 401) {
        acessoUtils.redirecionarSemTokenParaLogin();
      }
    }
  )
    .then(
      blob => {
        const data = window.URL.createObjectURL(blob);
        var iFrame = document.getElementById("iFrameAnexo");
        iFrame.src = data;
      }
    )
    .catch(
      error => console.error(error)
    )
  }

  async downloadMultipleFile(url, controlador) {
    this.ultimosControladores.get = this.selecionarControlador(controlador);
    const init = {
    headers: {
      'Accept-Encoding': 'gzip,deflate,sdch',
      'Accept': 'application/zip',
      'Authorization': 'Bearer ' + this.adquirirToken()
    },
    signal: this.ultimosControladores.get.signal
    }
    return fetch(url, init).then(
      response => {
        if (response.ok) {
          return response.blob()
        }

        if (response.status === 401) {
          acessoUtils.redirecionarSemTokenParaLogin();
        }
      }
    )
      .then(
        blob => {
          const data = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = data;
          link.download = 'documentos.zip';
          document.body.appendChild(link);
          try {
            link.click();
          } catch (e) {
            console.error(e);
          }
        }
      )
      .catch(
        error => console.error(error)
      )
  }

  async delete(url, item, controlador) {
    this.ultimosControladores.delete = this.selecionarControlador(controlador);
    const init = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.adquirirToken()
      },
      signal: this.ultimosControladores.delete.signal
    }
    const response = await fetch(url + '/' + item.id, init)

    if (response.ok) {
      return response
    }
    if (response.status === 401) {
      return acessoUtils.redirecionarSemTokenParaLogin();
    }

    throw new Error('HTTP ' + response.status)
  }

  async post(url, dto, controlador) {
    this.ultimosControladores.post = this.selecionarControlador(controlador);
    delete dto.id

    const init = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.adquirirToken()
      },
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify(dto),
      signal: this.ultimosControladores.post.signal
    }

    return fetch(url, init).then(response => response)
  }

    async postWithoutConvertingBody(url, dto, controlador) {
    this.ultimosControladores.post = this.selecionarControlador(controlador);
    delete dto.id

    const init = {
      headers: {
        'Authorization': 'Bearer ' + this.adquirirToken(),
      },
      credentials: 'include',
      method: 'POST',
      body: dto,
      signal: this.ultimosControladores.post.signal
    }

    return fetch(url, init).then(response => response)
  }

  async patch(url, dto, controlador) {
    this.ultimosControladores.patch = this.selecionarControlador(controlador);
    const init = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.adquirirToken()
      },
      method: 'PATCH',
      body: JSON.stringify(dto),
      signal: this.ultimosControladores.patch.signal
    }

    return fetch(`${url}/${dto.id}`, init)
      .then(response => response)
      .catch(error => error)
  }

  async save(url, dto, controlador) {
    if (dto.id) {
      return this.patch(url, dto, controlador)
    }
    return this.post(url, dto, controlador)
  }

  /**
   * Parametro base para abortar o request.
   * Se houver um controle de instância, aborta a instância;
   * Se não, aborta pelo tipo informado;
   * @param {String} tipo Tipo do request a ser abortado;
  */
   abortarUltimoRequest(tipo) {
    if(!!this.controleDeInstancia) {
        this.controleDeInstancia.abort();
    } else {
      this.#abortarUltimoRequestPorTipo(tipo);
    }
}

  /**
   * Aborta o último request do tipo informado na instância do
   * service, e retorna se um abort foi feito.
   * @private
   * @param {String} tipo tipo de request a ser abortado
   * @returns {Boolean} Retorna se abortou algum request;
   */
  #abortarUltimoRequestPorTipo(tipo) {
    switch(tipo) {
      case 'get':
        this.ultimosControladores.get.abort();
        return true;
      case 'delete':
        this.ultimosControladores.delete.abort();
        return true;
      case 'post':
        this.ultimosControladores.post.abort();
        return true;
      case 'patch':
        this.ultimosControladores.patch.abort();
        return true;
      default:
        return false;
    }
  }

  /**
   * Se houver um controle de Instância, aborta a instância.
   * Se não aborta o último request de cada tipo na instância.
   */
  abortarTodosOsUltimosRequests() {
    if(!!this.controleDeInstancia) {
      this.controleDeInstancia.abort();
    } else {
      for(controlador in this.ultimosControladores) {
        controlador.abort();
      }
    }
  }

  /**
     * Seleciona um AbortController para o request;
     *
     * Se um controlador for infornado, retorna aquele controlador
     * Setando o default para o controlador de instância, se houver,
     * Não tendo um controlador, gera um novo.
     *
     * @param {AbortController} controlador (opcional): Um AbortController
     * fornecido, aceita como parametro padrão o controlador geral;
     * @returns {AbortController} Retorna um AbortController para utilização no service;
     */
   selecionarControlador(controlador = this.controleDeInstancia) {
    if(!!controlador) {
        return controlador;
    } else {
        return new AbortController();
    }
}

  /**
   * Converte um objeto javascript padrão {chave: valor} para uma QueryString
   * para uso em requisições e retorna esta string;
   * @param {Object} objetoDeFiltros Objeto javascript padrão {chave: valor}
   * para ser convertido em queryString
   * @returns {String} QueryString para requisição
   * @deprecated
   */
  converterObjetoDeFiltrosParaQueryString(objetoDeFiltros) {
    if (!!!objetoDeFiltros) return '';

    const inicioDaQueryString = '?';
    const objetoConvertidoEmString = new URLSearchParams(objetoDeFiltros).toString().replaceAll("%2520" , "%20");
    const queryStringFinal = inicioDaQueryString + objetoConvertidoEmString;

    return queryStringFinal;
  }

  /**
   * @todo Verificar se este metodo pode substituir o acima e caso sim remover o de cima;
   * Converte um objeto javascript padrão {chave: valor} para uma QueryString
   * para uso em requisições e retorna esta string;
   * @param {Object} objetoDeFiltros Objeto javascript padrão {chave: valor}
   * para ser convertido em queryString
   * @returns {String} QueryString para requisição
   */
  converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros) {
    let str = [];
    for (const parametro in objetoDeFiltros) {
      if (objetoDeFiltros.hasOwnProperty(parametro)) {
        str.push(encodeURIComponent(parametro) + "=" + encodeURIComponent(objetoDeFiltros[parametro]));
      }
    }
    str = "?"+str.join("&").replaceAll("%2520" , "%20");
    return str;
  }

  async buscarEconverterObjeto(url, tipo) {
    let listaDeObjetos = []
    let listaDeObjetosConvertido = []
    do {
      listaDeObjetos = await this.get(url);
      listaDeObjetosConvertido = [...listaDeObjetosConvertido, ...listaDeObjetos.data]
      url = listaDeObjetos.links.next
    } while (url !== null)
    return listaDeObjetosConvertido.map((element) => {
      return {
        value: parseInt(element.id),
        label: element.type !== tipo ? element.attributes.nome : `${element.attributes.idExterno} - ${element.attributes.nome}`
      };
    });
  }

  async buscarObjeto(url) {
    let listaDeObjetos = []
    let listaDeObjetosConvertido = []
    do {
      listaDeObjetos = await this.get(url);
      listaDeObjetosConvertido = [...listaDeObjetosConvertido, ...listaDeObjetos.data]
      url = listaDeObjetos.links.next
    } while (url !== null)
    return listaDeObjetosConvertido;
  }
}

export const service = new Service()
